<form [formGroup]="form">
    <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{label}}</mat-label>
        <input matInput [formControlName]="controlName" maxlength="18" data-test="campo-documento"
            (blur)="onBlurOrEnter()" (keydown.enter)="onBlurOrEnter()">
        <mat-error *ngIf="formControlDocument.invalid">{{messageError.errorMessage(formControlDocument)}}</mat-error>
        <mat-icon matPrefix *ngIf="showIcon">assignment</mat-icon>
    </mat-form-field>
</form>